import React from 'react';
import './Mobile.scss';

export default function(props) {
	return <div className="Mobile">{props.children}</div>;
};
